import React from 'react'
import {findApiV4Link} from 'shared'

export default class ContentHeader extends React.Component {
  state = {}

  get profilePicture() {
    if (this.props.fundraisingEvent.profile_picture.fallback) return null
    return findApiV4Link({ofObject: this.props.fundraisingEvent.profile_picture, withRel: 'fill_730x380'})
  }

  get contactPicture() {
    return findApiV4Link({ofObject: this.props.fundraisingEvent.contact.picture, withRel: 'fill_100x100'})
  }

  get headerPicture() {
    return findApiV4Link({ofObject: this.props.fundraisingEvent, withRel: 'header_picture'})
  }

  get styleAttrs() {
    if (this.headerPicture) {
      return {backgroundImage: `url(${this.headerPicture})`, backgroundRepeat: 'no-repeat'}
    }
  }

  get imageOrVideo() {
    if (this.props.videoUrl) {
      return <div className="col-md-14 offset-md-5 fundraising-event-video text-center">
        <iframe
          allowFullScreen={true}
          type='text/html'
          width='508'
          height='286'
          id='fundraising-event-video-player'
          src={this.props.videoUrl}
          frameBorder="0"
        />
      </div>
    } else {
      return <div className="col-md-14 offset-md-5">
        <div className="fundraising-event-profile-picture center-block">
          <img src={this.profilePicture} height="286" />
        </div>
      </div>
    }
  }

  get largeTitle() {
    return <div className='col-md-24'>
      <div className='fundraising-event-title text-center'>
        <h1 className='font-xl is-lighter m-b' dangerouslySetInnerHTML={{ __html: this.props.fundraisingEvent.title }}/>
      </div>
    </div>
  }

  componentDidMount() {
    if (this.props.videoUrl) {
      window.onYouTubeIframeAPIReady = this.onYTReady
      const script = document.createElement('script')
      script.src = 'https://www.youtube.com/iframe_api'
      var firstScriptTag = document.getElementsByTagName('script')[0]
      firstScriptTag.parentNode.insertBefore(script, firstScriptTag)
    }
  }

  onYTReady = () => {
    let player = new YT.Player('fundraising-event-video-player', {
      events: {
        onStateChange: () => this.state.videoStarted || this.setState({videoStarted: true})
      }
    })
  }

  render() {
    const hasMedia = this.props.videoUrl || this.profilePicture

    return <div style={this.styleAttrs} className={`generic-content-header generic-background-color background-color-blue-medium fundraising-events-content-header ${hasMedia ? 'has-media' : 'has-no-media'} ${this.headerPicture ? 'has-custom-bg' : ''}`}>
      <div className="container preserves-space-for-transparent-header">
        <div className="row">
          {hasMedia ? this.imageOrVideo : this.largeTitle}
        </div>
        <div className={`fundraising-event-manager-picture-container ${this.state.videoStarted ? 'moved-to-background' : ''}`}>
          <div style={{display: 'inline-block', verticalAlign: 'middle', height: 140}} />
          <img className={`fundraising-event-manager-picture ${this.props.sponsoringPicture ? 'has-sponsoring' : ''}`} src={this.props.sponsoringPicture || this.contactPicture} />
        </div>
      </div>
    </div>
  }
}
